import IClaimWhitespace from "interfaces/responses/IClaimWhitespace";
import { GlobalState } from "little-state-machine";

export const updateAssignedClaimsWhitespace = (state: GlobalState, assignedClaimsWhitespace: IClaimWhitespace[]) => ({
  ...state,
  assignedClaimsWhitespace
});
